import PlayArrowRounded from '@mui/icons-material/PlayArrowRounded';
import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Review from '../../review/components/Review';
import TourList from '../../tour-offer/components/home/TourList';
import Landing from '../components/landing/Landing';
import LandingVideo from '../components/landing-video/LandingVideo';
import HotelDetails from '../../hotel/HotelDetails';
import HomeGallerySection from '../../gallery/components/HomeGallerySection';
import HomeAboutPreview from '../components/HomeAboutPreview';
import HomeFollowUsSection from '../components/HomeFollowUsSection';
import Sponsors from '../components/Sponsors';
import GlassCtaButton from '../../common/GlassCtaButton';

interface HomePageProps {
}

const HomePage: React.FC<HomePageProps> = ({ }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t("seo.home.title")}</title>
                <meta name="description" content={t("seo.home.description")} />
                <link rel="canonical" href="https://enduro-connection-radusa.com/" />
                <meta property="og:title" content={t("seo.home.title")} />
                <meta property="og:description" content={t("seo.home.ogDescription")} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://enduro-connection-radusa.com/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "TouristTrip",
                        name: "Enduro ture po planinama Bosne i Hercegovine",
                        description:
                            "Enduro ture po planinama Bosne i Hercegovine uz iskusnog vodiča, prilagođene različitim razinama vozača.",
                        url: "https://enduro-connection-radusa.com/",
                        areaServed: {
                            "@type": "Country",
                            name: "Bosna i Hercegovina",
                        },
                    })}
                </script>
            </Helmet>

            <Box
                width={"100vw"}
                marginLeft={"calc(50% - 50vw)"}>
                <LandingVideo />
            </Box>

            <Box sx={{ pt: 5, px: 2, display: 'flex', justifyContent: 'center' }}>
                <GlassCtaButton
                    onClick={() => navigate('/gallery?tab=video')}
                    leadingIcon={<PlayArrowRounded sx={{ fontSize: 32, ml: 0.25 }} />}
                >
                    {t('gallery.videoGallery')}
                </GlassCtaButton>
            </Box>

            <HomeFollowUsSection />

            <HomeAboutPreview />

            <HomeGallerySection />

            <Landing />

            <Sponsors />

            {/* <TourList /> */}

            {/* <HotelDetails /> */}

            <Box mt={6}>
                <Review />
            </Box>
        </>
    )
}

export default HomePage;